<template>
  <div :class="['custom-chip', { 'green-chip': greenChip, bold }]">
    <slot> </slot>
  </div>
</template>

<script>
export default {
  name: 'CustomChip',
  props: {
    greenChip: {
      type: Boolean,
      default: false,
    },
    bold: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-chip {
  padding: 5px 12px;
  border-radius: 16px;
  font-size: 14px;
  background-color: $cinza-l90;
  color: $cinza-d20;
  white-space: nowrap;
  width: fit-content;
  user-select: none;
}

.green-chip {
  background: #0fc94d1a;
  color: $verde-0;
}

.bold {
  font-weight: bold;
}
</style>
